/*
 *   Copyright (c) 2021 vlinder Labs Private Limited
 *   All rights reserved.
 *   This software is proprietary of Vlinder Labs Pvt. Ltd and can not be distributed / used for any purpose outside of Vlinder Labs Pvt. Ltd without explicit written consent from the copyright owner.
 */
import { createAgent } from '@vlinder-web/plugin-agent-service-react';
import {
  ISignInUserMethods,
  SignInUserService,
  IStaticPageContentMethods,
  StaticPageContentService,
  GetEmailDetailsService,
  IGetEmailDetailsMethods,
} from './components';

export type SignInPageAgent = ISignInUserMethods &
  IStaticPageContentMethods &
  IGetEmailDetailsMethods;

const getPlugins = () => {
  return [
    new SignInUserService(),
    new StaticPageContentService(),
    new GetEmailDetailsService(),
  ];
};

export const getAgent = () => {
  return createAgent<SignInPageAgent>({
    plugins: getPlugins(),
  });
};
